import { PERSONAL_EMAIL_DOMAINS } from "@/shared/constants";

/** Business domain from an email, or `null` when missing, malformed, or from a personal/free provider. */
export const getBusinessDomain = (email?: string | null): string | null => {
  if (!email) return null;
  const parts = email.trim().split("@");
  // Reject anything that isn't exactly `local@domain` with a non-empty local part.
  if (parts.length !== 2 || !parts[0]) return null;
  const domain = parts[1].trim().toLowerCase();
  const labels = domain.split(".");
  if (labels.length < 2 || labels.some((label) => !label)) return null;
  return PERSONAL_EMAIL_DOMAINS.has(domain) ? null : domain;
};
